import React from 'react';
import PropTypes from 'prop-types';

export default class AnswerYesNo extends React.Component {
  componentDidMount() {
    const { answerHandler } = this.props;
    answerHandler(['0']);
  }

  readInput = (event) => {
    const { answerHandler } = this.props;
    answerHandler([event.target.value]);
  };

  render() {
    const {
      answerValues,
      inputValue,
    } = this.props;

    return (
      <div className="adventcount-modal-radio">
      {answerValues.map((answerValue, index) => (
          <div className="adventcount-modal-radio-answer" key={`${answerValue}-${index + 1}`}>
            <label htmlFor={`radio-answer-${index}`}>
              <input id={`radio-answer-${index}`} type="radio" checked={parseInt(inputValue, 10) === index} value={index} onChange={this.readInput} />
              {answerValue}
            </label>
          </div>
      ))}
    </div>
    );
  }
}

AnswerYesNo.propTypes = {
  answerValues: PropTypes.arrayOf(PropTypes.string).isRequired,
  answerHandler: PropTypes.func.isRequired,
  inputValue: PropTypes.arrayOf(PropTypes.string).isRequired,
};
